import axiosInstance from '@/libs/axios_config'
import { z } from 'zod'
import { FamilyApplicationEndpoints } from '../family_application/requests'
import { AppealSchema } from './appeals.schema'
import { RequestResponse } from '@/common/types_and_interfaces.ts'
import {
  ApplicationAppealDetail,
  ApplicationAppealDetailSchema,
} from '@/apis/user_appeals/appeal_details.schema.ts'
import { parseRequestError } from '@/common/utilities.ts'

const ApplicationAppealsEndpoints = {
  getDetails: '/appeals/:appealId',
} as const

export const GETUserAppeals = async () => {
  const response = await axiosInstance.get(
    FamilyApplicationEndpoints.get_user_appeals
  )

  return z.array(AppealSchema).parse(response.data)
}

export const GETApplicationAppealDetails = async (
  appealId: number
): Promise<RequestResponse<ApplicationAppealDetail>> => {
  try {
    const response = await axiosInstance.get(
      ApplicationAppealsEndpoints.getDetails.replace(
        ':appealId',
        appealId.toString()
      )
    )

    console.log(ApplicationAppealDetailSchema.safeParse(response.data).error?.message)
    return {
      data: ApplicationAppealDetailSchema.parse(response.data),
      error: null,
    }
  } catch (e) {
    return {
      data: null,
      error: parseRequestError(e),
    }
  }
}
